import { render, staticRenderFns } from "./ProfileBackend.vue?vue&type=template&id=10fcd55b&"
import script from "./ProfileBackend.vue?vue&type=script&lang=js&"
export * from "./ProfileBackend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports